export const BILLING_COLUMNS = {
    date: { id: 'date', label: 'Date', default: true },
    callId: { id: 'callId', label: 'Call ID', default: false },
    assistant: { id: 'assistant', label: 'Assistant', default: true },
    from: { id: 'from', label: 'From', default: true },
    to: { id: 'to', label: 'To', default: true },
    duration: { id: 'duration', label: 'Duration (mins)', default: true },
    chargedDuration: { id: 'chargedDuration', label: 'Charged Duration (mins)', default: true },
    rate: { id: 'rate', label: 'Rate (SGD/min)', default: false },
    totalCost: { id: 'totalCost', label: 'Total Cost (SGD)', default: true },
    recording: { id: 'recording', label: 'Recording', default: true },
    direction: { id: 'direction', label: 'Direction', default: true },
    log: { id: 'log', label: 'Log', default: false }
};

// Helper function to get default visible columns
export const getDefaultVisibleColumns = () => {
    return Object.entries(BILLING_COLUMNS)
        .filter(([_, column]) => column.default)
        .map(([_, column]) => column.id);
};

// Helper function to get default billing columns state
export const getDefaultBillingColumnsState = () => {
    return Object.entries(BILLING_COLUMNS).reduce((acc, [key, column]) => {
        acc[key] = column.default;
        return acc;
    }, {});
}; 
